import { init as initSelect } from '@/commons/select';
import { getParameters } from '../customer-utils';

export const init = () => {
  const form = cube.$('.profile-block__form');
  const button = cube.$$('.edit-button, .cancel-button');

  initSelect();

  button.on('click', toggleForm);
  form.on('submit', setCommunicationLanguage);
};


/**
 * Open or close the communication language form
 *
 * @param {Event} e
 */
function toggleForm (e) {
  e.preventDefault();

  const block = this.closest('.profile-block');
  const classes = block.classList;

  if (classes.contains('profile-block--info')) {
    classes.add('profile-block--edit');
    classes.remove('profile-block--info');
  }
  else {
    classes.add('profile-block--info');
    classes.remove('profile-block--edit');
  }
};



/**
 * Disable the form and send to the API the new language value
 *
 * @param {Event} e
 */
function setCommunicationLanguage (e) {
  e.preventDefault();

  const submitButton = this.$('.submit-button');
  const params = getParameters(this);

  cube.cartridge('my-language')
    .before(() => cube.ui.disable(submitButton))
    .after(() => {
      init();
      cube.alert.success(window.Messages('profile.changesSaved'));
      cube.ui.enable(submitButton);
    })
    .reload(params);
}


// WEBPACK FOOTER //
// ./src/customer/account/account-language.js